import React from "react";
import ComingSoon from "../Common/ComingSoon.jsx";

const MembersDirectoryPage = () => <ComingSoon />;

export default MembersDirectoryPage;

